module.exports = __webpack_public_path__ + "static/plants-4-20c834232de98d26b220aa25636a70d1.jpg";